<template>
    <component :is="template">
        <div class="contents-area">
            <!-- <div class="tit-wrap tit-wrap--unberline">
                <h2 class="tit">베스트 셀러</h2>
            </div> -->

            <div class="contents-area__inner">
                <div v-if="category" class="mb-30px mb-md-40px">
                    <!-- <v-tabs show-arrows grow class="tab tab--block" multiple>
                        <v-tab @click="filter._category = category._id">전체</v-tab>
                        <v-tab v-for="category in category.children" :key="category._id" @click="filter._category = category._id">{{ category.name }}</v-tab>
                    </v-tabs> -->
                    <v-btn-toggle class="w-100" :light="true">
                        <v-row no-gutters class="row-cols-md-5 my-n4px">
                            <v-col class="py-4px">
                                <v-btn :class="filter._category == category._id ? 'primary' : 'v-btn--outlined grey--text'" block x-large @click="setCategory(category._id)">
                                    <span :class="filter._category == category._id ? '' : 'grey--text text--darken-3'">전체</span>
                                </v-btn>
                            </v-col>
                            <template v-for="category in category.children">
                                <v-col :key="category._id" class="py-4px">
                                    <v-btn :class="filter._category == category._id ? 'primary' : 'v-btn--outlined grey--text'" block x-large @click="setCategory(category._id)">
                                        <span :class="filter._category == category._id ? '' : 'grey--text text--darken-3'">{{ category.name }}</span>
                                    </v-btn>
                                </v-col>
                            </template>
                        </v-row>
                    </v-btn-toggle>
                </div>
                <div class="best-slide-wrap">
                    <div class="best-slide">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div v-for="product in bestOfBests" :key="product._id" class="swiper-slide">
                                    <router-link :to="`/shop/bestseller/${product._id}`">
                                        <div class="best-slide__img" :style="'background-image:url(' + product.thumb + ');'"></div>
                                        <div class="mt-4 text-center grey--text text--darken-4">
                                            <div class="font-size-18 font-size-md-20 font-weight-medium text-truncate">{{ product.name }}</div>
                                            <v-layout class="font-size-14 text-truncate mt-1" justify-center>
                                                <span>{{ product.writer }}</span>
                                                <v-divider v-if="product.writer && product.publisher" vertical class="mx-2 my-1" />
                                                <span>{{ product.publisher }}</span>
                                            </v-layout>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-control">
                            <div class="swiper-prev"><v-icon color="white">mdi-chevron-left</v-icon></div>
                            <div class="swiper-next"><v-icon color="white">mdi-chevron-right</v-icon></div>
                            <!-- <div class="swiper-pagination"></div> -->
                        </div>
                    </div>
                </div>

                <!-- <v-carousel height="auto" hide-delimiters class="white" text>
                    <v-carousel-item v-for="page in Math.ceil(bestOfBests.length / columnCount)" :key="page" :ripple="false">
                        <v-layout class="mx-n1">
                            <v-flex :xs3="columnCount == 4" :xs6="columnCount == 2" v-for="product in bestOfBests.filter((product, index) => (page - 1) * columnCount <= index && index < page * columnCount)" :key="product._id" class="px-1">
                                <router-link :to="`/shop/products/${product._id}`">
                                    <v-img :src="product.thumb" width="100%" :aspect-ratio="500/300" contain class="mx-auto"></v-img>
                                    <div class="mt-4 text-center grey--text text--darken-4">
                                        <div class="font-size-18 font-size-md-20 font-weight-medium text-truncate">{{ product.name }}</div>
                                        <v-layout class="font-size-14 text-truncate mt-1" justify-center>
                                            <span>{{ product.writer }}</span>
                                            <v-divider v-if="product.writer && product.publisher" vertical class="mx-2 my-1"/>
                                            <span>{{ product.publisher }}</span>
                                        </v-layout>
                                    </div>
                                </router-link>
                            </v-flex>
                        </v-layout>
                    </v-carousel-item>
                </v-carousel> -->

                <div class="mt-30px">
                    <v-divider class="border-2 grey lighten-1" />
                    <div class="py-10px py-md-6px">
                        <v-row align="center" class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="font-size-14">
                                    검색된 상품: <b class="primary--text">{{ summary.totalCount.format() }}</b
                                    >개
                                </div>
                            </v-col>
                            <v-spacer />
                            <v-col cols="12" md="auto">
                                <v-select v-model="sort" :items="sortItems" item-text="text" value="value" outlined hide-details @input="search(false)" />
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider class="grey lighten-1" />
                </div>

                <div class="py-20px py-md-30px">
                    <v-row>
                        <v-col v-for="product in products" :key="product._id" cols="6" md="3">
                            <router-link :to="{ path: `/shop/bestseller/${product._id}`, query: { ...filter } }">
                                <v-img :src="product.thumb" width="100%" :aspect-ratio="200 / 160" contain class="mx-auto"></v-img>
                                <div class="mt-4 text-center grey--text text--darken-4">
                                    <div class="font-size-18 font-size-md-20 font-weight-medium text-truncate">{{ product.name }}</div>
                                    <v-layout class="font-size-14 text-truncate mt-1" justify-center>
                                        <span class="text-truncate">{{ product.writer }}</span>
                                        <v-divider v-if="product.writer && product.publisher" vertical class="mx-2 my-1" />
                                        <span class="text-truncate">{{ product.publisher }}</span>
                                    </v-layout>
                                    <div class="d-flex align-center justify-center primary--text mt-md-1">
                                        <span class="font-size-16 font-size-md-18 font-weight-bold">{{ product.salePrice.format() }}</span>
                                        <small class="font-size-14 font-weight-medium ml-1">원</small>
                                    </div>

                                    <v-layout wrap justify-center class="mt-2 mr-n1">
                                        <v-flex v-if="product.isRecommend" shrink class="pr-1"><v-chip color="#FA647D" dark x-small>추천</v-chip></v-flex>
                                        <v-flex v-if="product.isNewly" shrink class="pr-1"><v-chip color="#FFAE00" dark x-small>신상품</v-chip></v-flex>
                                        <v-flex v-if="product.isPopular" shrink class="pr-1"><v-chip color="#32C081" dark x-small>인기</v-chip></v-flex>
                                        <v-flex v-if="product.isBest" shrink class="pr-1"><v-chip color="#1AB5BB" dark x-small>베스트</v-chip></v-flex>
                                    </v-layout>
                                </div>
                            </router-link>
                        </v-col>
                    </v-row>
                </div>
                <v-divider class="border-2 grey lighten-1" />

                <div class="mt-30px mt-md-40px">
                    <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" color="primary" />
                </div>
            </div>
        </div>
    </component>
</template>
<script>
import api from "@/api";
import Swiper from "swiper/bundle";

export default {
    data() {
        return {
            swiper: undefined,

            filter: {
                type: "main",
                _category: null,
            },

            category: null,

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 20,
            sort: null,
            sortItems: [
                { text: ":: 순서선택 ::", value: null },
                { text: "최근등록순", value: "byLatest" },
                { text: "인기순", value: "byPopular" },
                { text: "낮은가격순", value: "byLowPrice" },
                { text: "높은가격순", value: "byHighPrice" },
            ],

            summary: { totalCount: 0 },
            products: [],

            bestOfBestsLimit: 8,
            bestOfBests: [],
            items: [
                {
                    src: "backgrounds/bg.jpg",
                },
                {
                    src: "backgrounds/md.jpg",
                },
                {
                    src: "backgrounds/bg-2.jpg",
                },
                {
                    src: "backgrounds/md2.jpg",
                },
            ],
            selected: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { categories } = await api.v1.shop.categories.gets({ params: { depth: 1 } });
            this.category = categories.find((category) => category.code == "book")?.children?.find?.((category) => category.code == "bestseller");

            this.filter._category = this.$route.query._category ? this.$route.query._category : this.category?._id;

            this.searchBests();
            this.search(false);

            this.$nextTick((_) => {
                setTimeout(() => {
                    var swiper = new Swiper(".best-slide .swiper-container", {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 14,
                        // autoplay: {
                        //     delay: 3000,
                        //     disableOnInteraction: false,
                        // },
                        speed: 500,
                        loop: true,
                        // pagination: {
                        //     el: '.best-slide .swiper-pagination',
                        // },
                        navigation: {
                            nextEl: ".best-slide .swiper-next",
                            prevEl: ".best-slide .swiper-prev",
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 3,
                                slidesPerGroup: 3,
                            },
                            1024: {
                                slidesPerView: 4,
                                slidesPerGroup: 4,
                            },
                        },
                    });
                }, 300);
            });
        },
        async searchBests() {
            let { products: bestOfBests } = await api.v1.shop.products.gets({
                headers: {
                    limit: this.bestOfBestsLimit,
                },
                params: {
                    _category: this.filter._category,
                    isRecommend: true,
                    soldout: false,
                },
            });
            this.bestOfBests = bestOfBests;
        },
        async search(routable = false) {
            if (routable) {
                this.$router.push({ query: { ...this.filter, page: this.page } });
            }
            let { summary, products } = await api.v1.shop.products.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                    sort: this.sort,
                },
                params: this.filter,
            });

            this.products = products;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        setCategory(_category) {
            this.filter._category = _category;
            this.page = 1;
            this.search(true);
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.shop}`);
        },

        columnCount() {
            return this.$vuetify.breakpoint.mdAndUp ? 4 : 2;
        },
    },
    watch: {
        // "filter._category"() {
        //     this.page = 1;
        //     this.search(true);
        // },
        // "$route.query._category"() {
        //     this.filter._category = this.$route.query._category;
        // },
        "$route.query": {
            deep: true,
            handler() {
                this.page = +this.$route.query.page || 1;
                this.filter._category = this.$route.query._category;
                this.search(false);
                this.searchBests();
                window.scrollTo({ top: 0 });
            },
        },
    },
};
</script>

<style>
.best-slide-wrap {
    padding: 20px 12px;
    border: 2px solid var(--border-color);
}
.best-slide {
    position: relative;
}
.best-slide__img {
    width: 100%;
    padding-top: calc(260 / 300 * 100%);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
.best-slide .swiper-slide {
    width: 25%;
}
.best-slide .swiper-prev,
.best-slide .swiper-next {
    display: none;
    background-color: rgba(0, 0, 0, 0.12);
}
.best-slide .swiper-prev {
    left: 0;
}
.best-slide .swiper-next {
    right: 0;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .best-slide-wrap {
        border: 4px solid var(--border-color);
    }
    .best-slide {
        padding: 0 60px;
    }
    .best-slide .swiper-prev,
    .best-slide .swiper-next {
        display: flex;
        width: 50px;
        height: 50px;
    }
    .v-btn-toggle .row .col:not(:nth-child(5n)) .v-btn {
        border-right: none !important;
    }
}
@media (min-width: 1024px) {
    .best-slide-wrap {
        padding: 50px 12px;
    }
}
@media (min-width: 1200px) {
}
</style>
